import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Flex,
  Link,
  Image,
  HStack,
  Text,
} from '@chakra-ui/react';
import logo from '../assets/images/logo2.png';

const Navbar = () => {
  // const [searchValue] = useState('');
  // const navigate = useNavigate();

  // const handleSearch = (e) => {
  //   e.preventDefault();
  //   if (searchValue.trim()) {
  //     navigate(`/search/${searchValue}`);
  //   }
  // };

  return (
    <Box bg="green.400" py={4}>
      <Flex
        maxW="7xl"
        mx="auto"
        px={4}
        alignItems="center"
        justifyContent="space-between"
      >
        <Flex alignItems="center">
          <Link
            as={RouterLink}
            to="/"
            display="flex"
            alignItems="center"
            px={4}
            py={2}
            rounded={'md'}
            _focus={{
              outline: 'none'
            }}
            color="white"
          >
            <Flex align="center">
              <Image src={logo} alt="Nervosscan" h="8" mr={3} />
              <Text
                fontSize="2xl"
                fontWeight="semibold"
                color="white"
                whiteSpace="nowrap"
              >
                Nervosscan
              </Text>
            </Flex>
          </Link>
        </Flex>

        <HStack spacing={8} flex={1} justify="flex-end">
          <Link
            as={RouterLink}
            to="/"
            px={4}
            py={2}
            rounded={'md'}
            _focus={{
              outline: 'none'
            }}
            color="white"
          >
            Dashboard
          </Link>
          <Link
            as={RouterLink}
            to="/addresses"
            px={4}
            py={2}
            rounded={'md'}
            _focus={{
              outline: 'none'
            }}
            color="white"
          >
            Top Address
          </Link>
        </HStack>
      </Flex>
    </Box>
  );
};

export default Navbar;
